module.exports = __webpack_public_path__ + "img/elha-logo-black.c5a89845.svg";